

















import { PropType, toRef, getCurrentInstance, computed } from 'vue';
import { PostModel } from '../../../shared/models/post.model';
import Post from './Post.vue';
import { useDelayedVisibilityMarking } from '../../../shared/composables/useDelayedVisibilityMarking';
import { notificationAreas } from '../../../shared/enums/notificationAreas';
import { notificationEventTypes } from '../../../shared/enums/notificationEventTypes';
import { types } from '../../store/types/types.js';

export default {
  components: { Post },
  props: {
    posts: { type: Array as PropType<PostModel[]>, required: true },
  },
  emits: ['edit', 'delete', 'report'],
  setup(props) {
    const { proxy } = getCurrentInstance();
    const posts = toRef(props, 'posts');
    const notifications = computed(() => proxy.$store.getters[types.GET_NOTIFICATIONS]);
    const { itemRefs: postRefs } = useDelayedVisibilityMarking(posts, postId => {
      markPostAsRead(postId);
    });

    const markPostAsRead = postId => {
      const postNotifications = getNewPostNotifications(postId);
      if (postNotifications.length > 0) {
        proxy.$store.dispatch(types.DELETE_NOTIFICATIONS, { notifications: postNotifications });
      }
    };

    const getNewPostNotifications = postId =>
      notifications.value
        .filter(
          notification =>
            notification.notificationArea === notificationAreas.POSTS &&
            notification.postId == postId &&
            notification.notificationEventType === notificationEventTypes.POST_SHARED_WITH_ME
        )
        .map(notification => ({
          notificationId: notification.notificationId,
          institutionProfileId: notification.institutionProfileId,
        }));

    return {
      postRefs,
      notifications,
    };
  },
  methods: {
    emitEdit(postId) {
      this.$emit('edit', postId);
    },
    emitDelete(postId) {
      this.$emit('delete', postId);
    },
    emitReport(postId) {
      this.$emit('report', postId);
    },
  },
};
